/**
 * Who a voice of a transcript passage is, once somebody named it on the recording's page: drawn
 * the one way wherever the platform shows a passage outside that page (the passage panel of the
 * graph, a passage hit in the chat's search card). As a row of the workspace names a person: the
 * name first, cut when the line is short, then the tag in mono, which never breaks. A role is its
 * word alone. Size and colour come from the chip it stands in.
 */

import { useTranslation } from 'react-i18next'
import { type PassageSpeaker, speakerWords } from '@/features/humint/recording/passage-speakers'

export function PassageSpeakerName({ speaker }: { speaker: PassageSpeaker }) {
  const { t } = useTranslation()
  const { name, tag } = speakerWords(speaker, t)
  return (
    <span className="inline-flex min-w-0 items-baseline gap-1">
      <span className="truncate">{name}</span>
      {tag && <span className="shrink-0 whitespace-nowrap font-mono">{tag}</span>}
    </span>
  )
}
